<template>
  <div class="ryzz">
    <div class="ryzzdt">
      <div class="bg whbfb"></div>
      <div class="ryzzdt_">
        <div class="ryzzdt_s">
          <Swiper :options="swiperOption" ref="mySwiper">
            <Swiper-slide v-for="item in list" :key="item.id">
              <a href="javascript:;" title>
                <img :src="item.imageUrl" />
              </a>
            </Swiper-slide>
            <!-- <Swiper-slide>
              <a href="javascript:;" title>
                <img src="/static/management/20181204202444.jpg" />
              </a>
            </Swiper-slide>
            <Swiper-slide>
              <a href="javascript:;" title>
                <img src="/static/management/20181204202452.jpg" />
              </a>
            </Swiper-slide>
            <Swiper-slide>
              <a href="javascript:;" title>
                <img src="/static/management/20181204202502.jpg" />
              </a>
            </Swiper-slide>
            <Swiper-slide>
              <a href="javascript:;" title>
                <img src="/static/management/20181204202514.jpg" />
              </a>
            </Swiper-slide>
            <Swiper-slide>
              <a href="javascript:;" title>
                <img src="/static/management/20181204202534.jpg" />
              </a>
            </Swiper-slide>
            <Swiper-slide>
              <a href="javascript:;" title>
                <img src="/static/management/20181204202553.jpg" />
              </a>
            </Swiper-slide>-->
          </Swiper>

          <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
        </div>
        <a
          href="javascript:;"
          class="zhu1qh zhu2qh1"
          tabindex="0"
          role="button"
          aria-label="Previous slide"
          aria-disabled="false"
        >
          <img src="/static/management/qh1.png" />
        </a>
        <a
          href="javascript:;"
          class="zhu1qh zhu2qh2"
          tabindex="0"
          role="button"
          aria-label="Next slide"
          aria-disabled="false"
        >
          <img src="/static/management/qh2.png" />
        </a>
      </div>
    </div>
    <div class="vidlist vidlists swiper-container-horizontal">
      <Swiper :options="swiperOptionDown" ref="mySwiperDown">
        <Swiper-slide v-for="(item,index) in list" :key="item.id" :class="item.isActive?'cur':''">
          <a href="javascript:;" title @click="slideClick(item,index)">
            <img :src="item.imageUrl" />
          </a>
        </Swiper-slide>
      </Swiper>

      <div class="swiper-scrollbar">
        <div
          class="swiper-scrollbar-drag"
          style="width: 640.309px; transform: translate3d(0px, 0px, 0px);"
        ></div>
      </div>
      <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: [Object, Array]
  },
  data() {
    let that = this;
    return {
      list: this.$props.data || [],
      swiperOption: {
        autoplay: false,
        loop: false,
        nextButton: ".zhu2qh2",
        prevButton: ".zhu2qh1",

        // on: {
        //   init: function() {
        //     //this.activeIndex
        //     //   $('.vidlists .swiper-slide').eq(this.activeIndex).addClass('cur');
        //     that.list[this.activeIndex].isActive = true;
        //   },
        //   onSlideChangeEnd: function(swiper) {
        //     //    $('.vidlists .swiper-slide').removeClass('cur');
        //     //    $('.vidlists .swiper-slide').eq(this.activeIndex).addClass('cur');
        //     let arr = JSON.parse(JSON.stringify(that.list));
        //     console.log(swiper);
        //     arr.forEach(item => {
        //       item.isActive = false;
        //     });
        //     arr[swiper.activeIndex].isActive = true;
        //     that.$set(that.$data, "list", arr);
        //     that.swiperDown.slideTo(swiper.activeIndex, 200, false);
        //   }
        // }
        onInit: function(swiper) {
          //this.activeIndex
          //   $('.vidlists .swiper-slide').eq(this.activeIndex).addClass('cur');
          that.list[swiper.activeIndex].isActive = true;
        },
        onSlideChangeEnd: function(swiper) {
          //    $('.vidlists .swiper-slide').removeClass('cur');
          //    $('.vidlists .swiper-slide').eq(this.activeIndex).addClass('cur');
          let arr = JSON.parse(JSON.stringify(that.list));
          console.log(swiper);
          arr.forEach(item => {
            item.isActive = false;
          });
          arr[swiper.activeIndex].isActive = true;
          that.$set(that.$data, "list", arr);
          that.swiperDown.slideTo(swiper.activeIndex, 200, false);
        }
      },
      swiperOptionDown: {
        autoplay: false,
        loop: false,
        slidesPerView: 5,
        // slidesPerGroup: 5,
        spaceBetween: 20,
        scrollbar: ".swiper-scrollbar",
        scrollbarHide: false,
        scrollbarDraggable: true,
        breakpoints: {
          960: {
            slidesPerView: 4,
            spaceBetween: 5
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 5
          }
        }
      }
    };
  },
  computed: {
    // 定义swiper，在下面就可以引用这个swiper了；
    swiper: function() {
      return this.$refs.mySwiper.$swiper;
    },
    swiperDown: function() {
      return this.$refs.mySwiperDown.$swiper;
    }
  },
  created() {
    if (this.$props.data.length > 0) {
      let arr = this.$props.data.map(item => {
        item.isActive = false;
        return item;
      });
      arr[0].isActive = true;
      this.$set(this.$data, "list", arr);
    }
  },
  methods: {
    slideClick(item, index) {
      let arr = Object.assign([], this.list);
      arr.forEach(cell => {
        if (cell.id == item.id) {
          cell.isActive = true;
        } else {
          cell.isActive = false;
        }
      });
      this.swiperDown.slideTo(index, 400, false);
      this.swiper.slideTo(index, 400, false);
      this.$set(this.$data, "list", arr);
    }
  }
};
</script>